import ChevronRightIcon from '@atlaskit/icon/core/chevron-right';
import EditIcon from '@atlaskit/icon/core/edit';
import BulkEditValues, {
  type BulkEditValuesProps,
} from '@databases/action-bar/values/BulkEditValues';
import ButtonItem from '@databases/contextual-menu/ButtonItem';
import { messages } from '@databases/intl/messages';
import React from 'react';
import { useSnapshot } from 'valtio';

import { clearValues } from '../actions/clear-values';
import { submenu } from '../state/submenu-state';
import { SELECT_VALUE_MENU_ACTIONS, type MenuItemBuilder } from '../types';

export const bulkEditValuesMenuItem: MenuItemBuilder = ({
  capabilities: { canBulkEditValues },
  contentId,
  formatMessage,
  selectedValues,
  selectedValuesCount,
}) => {
  const BulkEditMenuItemTrigger: React.FC<React.ComponentProps<typeof ButtonItem>> = ({
    ref,
    ...triggerProps
  }) => {
    const state = useSnapshot(submenu.state);

    return (
      <ButtonItem
        isSelected={state.isOpen}
        iconAfter={<ChevronRightIcon label="" spacing="spacious" />}
        iconBefore={<EditIcon label="" spacing="spacious" />}
        onClick={submenu.toggle}
        onMouseEnter={submenu.open}
        ref={ref}
        {...triggerProps}
      >
        {formatMessage(messages['value-actions.bulk-edit-values'], {
          valuesCount: selectedValuesCount.toString(),
        })}
      </ButtonItem>
    );
  };

  const BulkMenuItemWrapper: React.FC<{ contentId: string }> = (props) => {
    const state = useSnapshot(submenu.state);

    return (
      <BulkEditValues
        contentId={props.contentId}
        removeSelectedContent={() => clearValues(props.contentId)}
        selectedValues={selectedValues}
        Trigger={BulkEditMenuItemTrigger as NonNullable<BulkEditValuesProps['Trigger']>}
        isOpen={state.isOpen}
        placement="right"
        offset={[0, 2]}
      />
    );
  };

  return {
    isEnabled: () => canBulkEditValues,
    menuItem: {
      key: SELECT_VALUE_MENU_ACTIONS.BULK_EDIT_VALUES,
      name: formatMessage(messages['value-actions.bulk-edit-values'], {
        valuesCount: selectedValuesCount.toString(),
      }),
      elemBefore: <EditIcon label="" spacing="spacious" />,
      content: <BulkMenuItemWrapper contentId={contentId} />,
      value: { name: SELECT_VALUE_MENU_ACTIONS.BULK_EDIT_VALUES },
    },
  };
};
